var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSber = function SvgSber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21A038",
    d: "M19.9108 5.94434C20.3832 6.56185 20.7781 7.23841 21.1121 7.95547L12.0097 14.7464L8.18652 12.3169V9.40983L11.9895 11.8191L19.9108 5.94434Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_38376_23257)",
    d: "M4.30471 12.1176C4.30471 11.9775 4.30471 11.8594 4.32495 11.7194L2.02025 11.5996C2.02025 11.7599 2 11.9387 2 12.0973C2 14.8863 3.12367 17.4154 4.93572 19.2477L6.57061 17.5942C5.17193 16.2006 4.30471 14.2688 4.30471 12.1176Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_38376_23257)",
    d: "M11.9897 4.35052C12.1281 4.35052 12.2462 4.35052 12.3845 4.37077L12.5026 2.04075C12.344 2.04075 12.1669 2.02051 12.01 2.02051C9.25139 2.02051 6.74928 3.15599 4.93555 4.98828L6.57044 6.64173C7.95056 5.22786 9.88071 4.35052 11.9897 4.35052Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_38376_23257)",
    d: "M11.9895 19.8859C11.8511 19.8859 11.733 19.8859 11.5947 19.8657L11.4766 22.1957C11.6352 22.1957 11.8123 22.216 11.9692 22.216C14.7278 22.216 17.2316 21.0805 19.0436 19.2482L17.4087 17.5947C16.0286 19.0288 14.117 19.8859 11.9895 19.8859Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_38376_23257)",
    d: "M16.3246 5.70508L18.275 4.25072C16.5608 2.8571 14.3742 2 11.9902 2V4.33002C13.6066 4.35026 15.1031 4.84798 16.3246 5.70508Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#21A038",
    d: "M21.9997 12.1187C21.9997 11.5012 21.9406 10.9039 21.8411 10.3066L19.6933 11.9196C19.6933 11.9787 19.6933 12.0596 19.6933 12.1187C19.6933 14.4099 18.7079 16.4615 17.1523 17.8754L18.7079 19.6081C20.7191 17.7758 21.9997 15.0865 21.9997 12.1187Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_38376_23257)",
    d: "M11.9895 19.886C9.72362 19.886 7.69393 18.8906 6.29524 17.3164L4.58105 18.8906C6.41335 20.9422 9.05381 22.216 11.9895 22.216V19.886Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_38376_23257)",
    d: "M6.84731 6.36165L5.29003 4.62891C3.26033 6.48145 2 9.15059 2 12.1184H4.30471C4.30471 9.8474 5.29003 7.77721 6.84731 6.36165Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38376_23257",
    x1: 4.68995,
    x2: 2.32292,
    y1: 18.9644,
    y2: 12.0913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1444,
    stopColor: "#F2E913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3037,
    stopColor: "#E7E518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5823,
    stopColor: "#CADB26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#A3CD39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38376_23257",
    x1: 5.59293,
    x2: 11.5736,
    y1: 4.72525,
    y2: 2.4358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0592,
    stopColor: "#0FA8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5385,
    stopColor: "#0099F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    stopColor: "#0291EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38376_23257",
    x1: 11.3419,
    x2: 18.4682,
    y1: 20.2342,
    y2: 18.6164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#A3CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    stopColor: "#86C339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8693,
    stopColor: "#21A038"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38376_23257",
    x1: 11.5167,
    x2: 17.4431,
    y1: 3.48463,
    y2: 5.32151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0566,
    stopColor: "#0291EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C8ACB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_38376_23257",
    x1: 5.16711,
    x2: 11.5342,
    y1: 19.2592,
    y2: 21.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1324,
    stopColor: "#F2E913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2977,
    stopColor: "#EBE716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#D9E01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8023,
    stopColor: "#BBD62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#A3CD39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_38376_23257",
    x1: 3.76648,
    x2: 6.32511,
    y1: 12.3999,
    y2: 5.7138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0698,
    stopColor: "#A3CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#81C55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9216,
    stopColor: "#0FA8E0"
  })))));
};
export default SvgSber;